import { Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
  selector: '[evkMatCaption]'
})
export class MatCaptionDirective {

    @HostBinding('class')
    public class = 'mat-caption';

}
